import type { ReactNode } from 'react';
import { colors } from '../../styles/theme';

interface Props {
  /** "What happens next?" accordion paragraphs (context-specific copy). */
  readonly paragraphs: readonly string[];
  /** The "Message your advisor" CTA row — caller wires the channel (a
   *  callback request for onboarding, the AssistanceModal for a contract). */
  readonly cta: ReactNode;
}

/**
 * Shared under-review panel (#49): a "What happens next?" accordion + a
 * caller-supplied advisor-contact CTA, so the silent review wait doesn't read as
 * a dead end. No turnaround is promised (#338): the outcome is e-mailed when it is
 * decided. Used by the contract review page.
 */
export default function ReviewNextSteps({ paragraphs, cta }: Props): JSX.Element {
  return (
    <div className="mt-6 space-y-4">
      <details
        className="rounded-xl overflow-hidden"
        style={{ border: `1px solid ${colors.border}` }}
      >
        <summary
          className="px-4 py-3 text-sm font-semibold cursor-pointer select-none"
          style={{ color: colors.ink, background: colors.canvas, listStyle: 'none' }}
        >
          What happens next?
        </summary>
        <div className="px-4 py-3 text-sm space-y-2" style={{ color: colors.inkSoft }}>
          {paragraphs.map((p) => (
            <p key={p.slice(0, 32)}>{p}</p>
          ))}
        </div>
      </details>

      {cta}
    </div>
  );
}
